import React from 'react'
import {
  IconWebinar,
  IconRightArrow,
  Row,
  StyledLink,
  WebinarLinkAndIcon,
} from './component.styles'
import { WEBINAR_LINK_TEXT, WEBINAR_PATH } from './contants'

const WebinarLinkIcon = () => {
  return (
    <Row>
      <StyledLink
        alt={WEBINAR_LINK_TEXT}
        data-testid="text-link-webinar"
        to={WEBINAR_PATH}
      >
        <WebinarLinkAndIcon>
          <IconWebinar aria-hidden="true" role="presentation" />
          {WEBINAR_LINK_TEXT}
        </WebinarLinkAndIcon>
      </StyledLink>
      <IconRightArrow />
    </Row>
  )
}

export default WebinarLinkIcon
